import { render } from "./ChooseCenter.vue?vue&type=template&id=f0ae8884&scoped=true"
import script from "./ChooseCenter.vue?vue&type=script&lang=js"
export * from "./ChooseCenter.vue?vue&type=script&lang=js"

import "./ChooseCenter.vue?vue&type=style&index=0&id=f0ae8884&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0ae8884"]])

export default __exports__